fccd-facet-input {
  width: 100%;
  hp5-label-decorator {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  hp5-input-search {
    display: contents;
  }

  hp5-filter-panel div.content {
    padding: 0 !important;
  }
}
